import { render, staticRenderFns } from "./PurchaseItemStock.vue?vue&type=template&id=22468a8f&"
import script from "./PurchaseItemStock.vue?vue&type=script&lang=js&"
export * from "./PurchaseItemStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports